export enum AssemblyDataType {
  Json,
  Csv,
}
